import React, { memo } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

import SelectedFile from '../entity/SelectedFile';
import PanelHeading from './PanelHeading';

const SelectedFilePanel = ({
    file,
    deleteFile,
    columnGridCount,
}) => (
    <Panel>
        <PanelHeading
            text={`${file.getUploadedFile().getName()} (${file.getSizeAsString()})`}
            iconClass="icon-ok text-success"
            customClass="collapsed"
            deleteFile={() => deleteFile(file.getId())}
            columnGridCount={columnGridCount}
        />
    </Panel>
);

SelectedFilePanel.propTypes = {
    file: PropTypes.instanceOf(SelectedFile).isRequired,
    deleteFile: PropTypes.func.isRequired,
    columnGridCount: PropTypes.number.isRequired,
};

export default compose(
    memo,
)(SelectedFilePanel);
